import EventScope from 'owa-service/lib/contract/EventScope';
import ItemId from 'owa-service/lib/contract/ItemId';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import { CalendarEvent } from 'mini-calendar-event-types';
import { ClientItemId } from 'owa-client-ids';
import { getCalendarEventService } from './getCalendarEventService';
import { GetDetailedCalendarEventOptions } from '../schema/GetDetailedCalendarEventOptions';
import { getOwaCanaryCookie } from 'owa-service/lib/canary';

/**
 * Loads the calendar event from the server based on item id
 * @param id Id of the event that we want to load
 * @param options Additional options while making the get detailed event api call
 * @param eventScope The scope/instance of event(like single instance, series, etc.)
 */
export const getDetailedCalendarEvent = (
    calendarEventId: ClientItemId,
    options: GetDetailedCalendarEventOptions,
    eventScope: EventScope = EventScope.Default,
    seriesMasterId?: ItemId
): Promise<CalendarEvent> => {
    const owaCanary = getOwaCanaryCookie();
    const shape: ItemResponseShape = {
        BaseShape: 'IdOnly',
        MaximumBodySize: 0, // No body truncation
        BodyType: 'HTML',
        InlineImageUrlTemplate: `/owa/service.svc/s/GetFileAttachment?id={id}&X-OWA-CANARY=${owaCanary}`,
        AddBlankTargetToLinks: true,
    };

    // Invoke the service to get the data
    return getCalendarEventService(calendarEventId, shape, options, eventScope, seriesMasterId);
};
